// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"505fb580","160":"2e024949","208":"6f0c43b8","293":"ec65c524","516":"1ccd4192","519":"cce7b904","917":"ed5b6b9c","946":"ac2fd6b7"}[chunkId] + ".chunk.js";
};